"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
const ScrollingState_1 = __importDefault(require("@web/common/ScrollingState"));
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
const setCookies_1 = require("@web/cookiesSettings/setCookies");
(() => {
    const cookiePolicyPanel = document.getElementById('cookie-policy-panel');
    const cookiePolicyPanelOptionsList = document.getElementById('gdpr-cookies-policy-options-CookiesPanel');
    const confirmAllCookiesButton = document.getElementById('confirm-all-cookies');
    const confirmSelectedCookiesButton = document.getElementById('confirm-selected-cookies');
    const denyAllCookiesButton = document.getElementById('deny-all-cookies');
    const cookiesSettingsButton = document.getElementById('cookies-settings');
    if (cookiePolicyPanel === null || cookiePolicyPanelOptionsList === null || confirmAllCookiesButton === null
        || confirmSelectedCookiesButton === null || denyAllCookiesButton === null || cookiesSettingsButton === null) {
        return;
    }
    const setSelectedCookies = (selectedCookiesEnum) => {
        (0, setCookies_1.setCookies)(selectedCookiesEnum, cookiePolicyPanelOptionsList, () => {
            DisplayAnimation_1.default.fadeOut(cookiePolicyPanel);
            if (ScreenSize_1.default.isSmallScreen()) {
                ScrollingState_1.default.enableScrolling();
            }
        });
    };
    confirmAllCookiesButton.addEventListener('click', (event) => {
        event.preventDefault();
        setSelectedCookies(setCookies_1.CookiesEnum.ALL);
    });
    confirmSelectedCookiesButton.addEventListener('click', (event) => {
        event.preventDefault();
        setSelectedCookies(setCookies_1.CookiesEnum.SELECTED);
    });
    denyAllCookiesButton.addEventListener('click', (event) => {
        event.preventDefault();
        setSelectedCookies(setCookies_1.CookiesEnum.NONE);
    });
    cookiesSettingsButton.addEventListener('click', (event) => {
        event.preventDefault();
        DisplayAnimation_1.default.hide(cookiesSettingsButton);
        DisplayAnimation_1.default.show(confirmSelectedCookiesButton);
        DisplayAnimation_1.default.hide(denyAllCookiesButton);
        cookiePolicyPanel.classList.toggle('open');
        const { titleSettings } = confirmAllCookiesButton.dataset;
        if (titleSettings === undefined) {
            return;
        }
        confirmAllCookiesButton.textContent = titleSettings;
        if (ScreenSize_1.default.isSmallScreen()) {
            ScrollingState_1.default.disableScrolling();
        }
    });
    window.addEventListener('resize', () => {
        const isPanelOpen = cookiePolicyPanel.classList.contains('open');
        if (isPanelOpen && ScreenSize_1.default.isSmallScreen()) {
            ScrollingState_1.default.disableScrolling();
        }
        else {
            ScrollingState_1.default.enableScrolling();
        }
    });
    const cookiePolicyPanelBackElement = cookiePolicyPanel.querySelector('.back');
    if (cookiePolicyPanelBackElement === null) {
        return;
    }
    cookiePolicyPanelBackElement.addEventListener('click', (event) => {
        event.preventDefault();
        DisplayAnimation_1.default.show(cookiesSettingsButton);
        DisplayAnimation_1.default.hide(confirmSelectedCookiesButton);
        DisplayAnimation_1.default.show(denyAllCookiesButton);
        cookiePolicyPanel.classList.toggle('open');
        const { titleOriginal } = confirmAllCookiesButton.dataset;
        if (titleOriginal) {
            confirmAllCookiesButton.textContent = titleOriginal;
        }
        if (ScreenSize_1.default.isSmallScreen()) {
            ScrollingState_1.default.enableScrolling();
        }
    });
})();
